import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $LeftColumn = styled.div``;

export const $Heading = styled.div`
  font-weight: 800;
  ${fontStyle('base')};
  @media ${media.minWidth.sm} {
    ${fontStyle('xl')};
  }

  color: ${({ theme }) => theme.systemColors.defaultTextColor};
  margin-bottom: ${spacing('lg')};
  display: flex;
  align-items: center;
`;

export const $HeadingIcon = styled.span`
  margin-right: ${spacing('lg')};
  display: flex;
  align-items: baseline;
  & svg {
    width: ${spacing('xl')};
    height: ${spacing('xl')};
  }
`;

export const $SolutionWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  @media ${media.minWidth.sm} {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: ${spacing('xxl')};
  }
`;

export const $SolutionItemWrapper = styled.div`
  flex: 1;
`;

export const $SolutionResultWrapper = styled.div`
  flex: 1;
  margin-bottom: ${spacing('xxl')};
`;
